import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { VscSymbolColor } from "react-icons/vsc";

const Wrapper = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 999;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const IconButton = styled.button`
  background: ${({ theme }) => theme.headerBg};
  border: none;
  border-radius: 50%;
  padding: 8px;
  font-size: 18px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);

  &:hover {
    opacity: 0.85;
  }
`;

const Dropdown = styled.div`
  background: ${({ theme }) => theme.headerBg};
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ThemeOption = styled.button`
  background: ${({ theme }) => theme.inputBg || "#fff"};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.text};
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.bubbleAgent || "#e5e5e5"};
  }
`;

const ThemeSelector = ({ themeName, setThemeName }) => {
    const [showOptions, setShowOptions] = useState(false);
    const dropdownRef = useRef();

    const toggleDropdown = () => setShowOptions((prev) => !prev);

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setShowOptions(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (value) => {
        setThemeName(value);
        setShowOptions(false);
    };

    const themes = [
        { value: "blue", label: "Azul Suave" },
        { value: "light", label: "Laranja" },
        { value: "dark", label: "Escuro" },
        { value: "night", label: "Noite Relaxante" },
        { value: "forest", label: "Floresta" },
        { value: "smoothBlack", label: "Preto Suave" },
    ];

    return (
        <Wrapper ref={dropdownRef}>
            {showOptions && (
                <Dropdown>
                    {themes.map((theme) => (
                        <ThemeOption
                            key={theme.value}
                            onClick={() => handleSelect(theme.value)}
                        >
                            {theme.label}
                        </ThemeOption>
                    ))}
                </Dropdown>
            )}
            <IconButton onClick={toggleDropdown}>
                <VscSymbolColor />
            </IconButton>
        </Wrapper>
    );
};

export default ThemeSelector;
